"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatorOffice = exports.connectionStringForOfficeAddinCLITools = exports.instrumentationKeyForOfficeAddinCLITools = exports.groupName = exports.usageDataJsonFilePath = void 0;
const os_1 = __importDefault(require("os"));
const path_1 = __importDefault(require("path"));
exports.usageDataJsonFilePath = path_1.default.join(os_1.default.homedir(), "/office-addin-usage-data.json");
exports.groupName = "office-addin-usage-data";
exports.instrumentationKeyForOfficeAddinCLITools = "de0d9e7c-1f46-4552-bc21-4e43e489a015";
exports.connectionStringForOfficeAddinCLITools = "InstrumentationKey=de0d9e7c-1f46-4552-bc21-4e43e489a015;IngestionEndpoint=https://westus2-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=8877f7e6-d54b-4ce8-a5c3-0393f788f174";
exports.generatorOffice = "generator-office";
//# sourceMappingURL=defaults.js.map